import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getLogin, setLoginError } from '../../services/redux/auth/actions';
import { ReactComponent as IconPassWhite } from '../../style/img/icon_pass_white.svg';
import { ReactComponent as IconUser } from '../../style/img/icon_user.svg';
import loginImg from '../../style/img/logo_white_login.png';
import digiconcreteLogo from '../../style/img/digiconcrete_logo.png';
import styles from './index.module.scss';
import Footer from '../../layout/Layout/components/Footer';
import AntdInput from '../../components/AntdInput';
import AntdFormItem from '../../components/AntdFormItem';
import { Checkbox, Form } from 'antd';
import { useForm } from 'antd/es/form/Form';
import AccionaAlert from '../../components/AccionaAlert';
import CryptoJS from 'crypto-js';
import { encryptionKey } from '../../constants/general';

const { wrapper, loginCard, logo, bottomLogo } = styles;

const Login = () => {
  const { formatMessage } = useIntl();
  const [form] = useForm();
  const dispatch = useDispatch();

  const { loginError, isLoggedIn } = useSelector(({ auth }) => auth);

  const retrieveUserCredentials = () => {
    const encryptedPassword = localStorage.getItem('password');

    if (encryptedPassword) {
      const bytes = CryptoJS.AES.decrypt(encryptedPassword, encryptionKey);
      const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);

      return decryptedPassword;
    }

    return undefined;
  };

  const onClickButton = async () => {
    await form
      .validateFields()
      .then(({ username, password, remember }) => {
        dispatch(getLogin({ username, password, remember }));
      })
      .catch((e) => {
        console.info(e);
      });
  };

  useEffect(() => {
    if (loginError) {
      setTimeout(() => {
        dispatch(setLoginError(false));
      }, 3000);
    }
  }, [dispatch, loginError]);

  if (isLoggedIn) {
    return <Navigate to="/app/projects" />;
  }

  return (
    <div className={wrapper}>
      <div>
        <div>
          <h1>
            <img src={digiconcreteLogo} alt="Acciona" className={logo} />
          </h1>
          <div className={loginCard}>
            <div>
              <Form form={form}>
                <AntdFormItem
                  initialValue={localStorage.getItem('username')}
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: formatMessage({ id: 'validations.required' }),
                    },
                  ]}
                >
                  <AntdInput
                    addonAfter={
                      <IconUser title={formatMessage({ id: 'login.user' })} />
                    }
                    placeholder={formatMessage({ id: 'login.user' })}
                  />
                </AntdFormItem>
                <AntdFormItem
                  initialValue={retrieveUserCredentials()}
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: formatMessage({ id: 'validations.required' }),
                    },
                  ]}
                >
                  <AntdInput
                    type="password"
                    addonAfter={
                      <IconPassWhite
                        title={formatMessage({ id: 'login.password' })}
                      />
                    }
                    placeholder={formatMessage({ id: 'login.password' })}
                  />
                </AntdFormItem>
                <AntdFormItem
                  name="remember"
                  valuePropName="checked"
                  initialValue={
                    localStorage.getItem('username') &&
                    localStorage.getItem('password')
                  }
                >
                  <Checkbox>{formatMessage({ id: 'login.remember' })}</Checkbox>
                </AntdFormItem>
              </Form>
              {loginError && (
                <AccionaAlert
                  message={formatMessage({ id: 'login.invalid' })}
                ></AccionaAlert>
              )}
            </div>
            <div>
              <button
                type="submit"
                className="button"
                onClick={() => {
                  onClickButton();
                }}
              >
                {formatMessage({ id: 'login.button' })}
              </button>
            </div>
          </div>
          <div className={bottomLogo}>
            <img src={loginImg} alt="Acciona" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Login;
